export const getTotalEmails = (state) => {
    return state.requestPayload.totemails
}

export const getTotalSpaceyEmails = (state) => {
    return state.requestPayload.totspaceyemails
}

export const getRequestPayload = (state) => {
    return state.requestPayload
}

export const getLastPage = (state) => {
    return state.lastpage
}

export const getHasNext = (state) => {
    return state.hasnext
}

export const getResponsePayload = (state) => {
    return state.responsePayload
}

export const getCurrentPage = (state) => {
    return state.requestPayload.page
}

export const getSortingField = (state) => {
    return state.requestPayload.sorting_field
}
export const getSortingDirection = (state) => {
    return state.requestPayload.sorting_direction
}

export const getStartTime = (state) => {
    return state.start_time
}

export const getEndTime = (state) => {
    return state.end_time
}

export const getPerPage = (state) => {
    return state.requestPayload.perpage
}

export const getIsFromSearch = (state) => {
    return state.isfromsearch
}

export const getIsLoading = (state) => {
    return state.isloading
}

export const getRequestPayloadPanelist = (state) => {
    return state.requestPayload.panelist
}

export const getPanelistScore = (state) => {
    return function(muid) {
        return state.responsePayload.find(o => o.muid === muid)
    }
}

export const getTotalSpacey2019Emails = (state) => {
    return state.requestPayload.totspacey2019emails
}

export const getPaging = (state) => {
    return state.paging
}

export const getUpdateObjects = (state) => {
    return state.update_objects
}

export const getAllChecked = (state) => {
    return state.update_all
}

export const getCheckedByMuid = (state) => {
    return function(muid) {
        return state.update_objects.find(o => muid === o.muid)
    }
}

export const getCompetiIds = (state) => {
    return state.competi_id
}

export const getProductId = (state) => {
    return state.product_id
}

export const getIdsToUpdate = (state) => {
    return state.ids_to_update
}
